export default {
    /**
     * Check max length of value
     * @param {String} val
     * @param {Number} maxLength
     * @return {Bool} Field is valid
     */
    maxLength: (val, maxLength) => val.length <= Number(maxLength),

    /**
     * Check value if required
     * @param {String} val
     * @param {Bool} isRequired
     * @return {Bool} Field is valid
     */
    required: (val, isRequired) => (isRequired ? !!val : true),

    /**
     * Check regexp
     * @param {String} val
     * @param {Regexp} regexp
     * @return {Bool} Field is valid
     */
    regularExpression: (val, regexp) => RegExp(regexp).test(val) || val === '',
}
